'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BasePredictor = require('./base.predictor');
var CurrencyPredictor = /*#__PURE__*/function (_BasePredictor) {
  function CurrencyPredictor() {
    var _this;
    _classCallCheck(this, CurrencyPredictor);
    _this = _callSuper(this, CurrencyPredictor, ['currency']);

    // Matches either a plain number or a number with properly placed commas and/or decimal point.
    var numberPattern = '(?:(?:\\d{1,3}(?:,\\d{3})+)|\\d+)(?:\\.\\d+)?';

    /**
     * For currencies that appear as a prefix (e.g. "$", "US$", "£", or "€"),
     * the minus sign may appear either immediately before or immediately after the symbol.
     * Since whitespace is removed before matching, tjere are three alternatives:
     *
     *   1. "-" + symbol + number
     *   2. symbol + "-" + number
     *   3. symbol + number
     *
     * @param {string} symbol - The literal (or grouped) symbol to match.
     * @param {string} [flags] - Optional regex flags (for example, "i" for case-insensitive).
     * @returns {RegExp} The constructed regular expression.
     */
    var buildPrefixRegex = function buildPrefixRegex(symbol) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return new RegExp("^(?:-".concat(symbol, "|").concat(symbol, "-|").concat(symbol, ")").concat(numberPattern, "$"), flags);
    };
    _this.patterns = [{
      // Dollar: matches both "$" and "US$", case-insensitively.
      regex: buildPrefixRegex('(?:US\\$|\\$)', 'i'),
      format: '$'
    }, {
      // Pound: symbol "£" must be at the beginning.
      regex: buildPrefixRegex('£'),
      format: '£'
    }, {
      // Euro (prefix): symbol "€" preceding the number.
      regex: buildPrefixRegex('€'),
      format: '€'
    }, {
      // Euro (trailing): number (with optional minus as part of it) followed by "€".
      // Note that for trailing currency the minus sign (if present) is allowed only as part of the number.
      regex: new RegExp("^-?".concat(numberPattern, "\u20AC$")),
      format: '€_after'
    }];
    return _this;
  }

  /**
   * Attempts to detect a currency value in the given string.
   *
   * first strips all whitespace (spaces, tabs, etc.) from the input,
   * then tests the cleaned value against a set of currency patterns. Only values that
   * contain one of the valid currency symbols (in the proper position) will match.
   *
   * @param {string} value - The input string to check.
   * @returns {object|null} An object of the form
   *   { type: 'currency', format: { format: <symbol> } }
   * if a currency is detected; otherwise, null.
   */
  _inherits(CurrencyPredictor, _BasePredictor);
  return _createClass(CurrencyPredictor, [{
    key: "predict",
    value: function predict(value) {
      // Remove all whitespace (spaces, tabs, etc.) to simplify the matching.
      var cleanedValue = value.replace(/\s/g, '');
      var pattern = this.patterns.find(function (_ref) {
        var regex = _ref.regex;
        return regex.test(cleanedValue);
      });
      if (pattern) {
        return {
          type: 'currency',
          format: {
            format: pattern.format
          }
        };
      }
      return null;
    }
  }]);
}(BasePredictor);
module.exports = CurrencyPredictor;